import { useState, useEffect } from 'react';
import Page from '../components/Page';
import resto596x920 from '../static/images/restaurant_1373_596x920_90_1_0_c.jpg';
import useScript from '../hooks/useScript';

const Restaurant = (props) => {



  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');


  useEffect(() => {
    fetch('./content/restaurant-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/restaurant-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>



  useScript("https://cdn.formitable.com/sdk/v1/ft.sdk.min.js");

  document.title = 'Restaurant DS - De School Amsterdam';
  const headerTitle = 'Restaurant DS';
  const description = 'Restaurant Restaurant Restaurant Restaurant Restaurant Restaurant ';
  const image = resto596x920;


  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}
          />

};

export default Restaurant;



